/**
  * 盲盒定制订单 接口的出口
  */
import axios from '../.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const manghemadeorder = {
    // 盲盒定制订单
    boxOrderList(params) {
        return axios.get(api + 'manghemadeorder/list', { params: params })
    },
    //导出盲盒定制订单
    exportboxorder(params) {
        return axios.get(api + 'manghemadeorder/export', { params: params })
    },
    // 盲盒定制订单详情
    boxOrderDetail(params) {
        return axios.get(api + 'manghemadeorder/detail', { params: params })
    },
    //导出盲盒定制订单
    // exportboxmadeorder(params) {
    //     return axios.get(api + 'manghemadeorder/export', { params: params })
    // },
}


// 导出接口
export default manghemadeorder
